const PORTAL = {
  nome: 'Campanha PME 2026',
  publico: ['Corretores', 'Administradoras', 'Parceiros'],
  periodo: '01/10/2026 → 31/12/2026',
  regras: [
    { faixa: '1 a 10 contratos', premio: '500 pontos' },
    { faixa: '11 a 20 contratos', premio: '1.500 pontos' },
    { faixa: '21+ contratos', premio: '3.000 pontos' },
  ],
  criterios: ['Contrato aprovado', 'Primeira mensalidade paga', 'Contrato ativo', 'Período de carência definido pelo cliente'],
};

const MOTOR_REGRAS = [
  {
    se: 'produto = PME',
    e: ['vidas ≥ 30', 'contrato = ATIVO', 'primeira cobrança = PAGA'],
    entao: 'Gerar 2.000 pontos',
  },
  {
    se: 'canal = CORRETOR',
    e: ['produto = EMPRESARIAL', 'vendas ≥ 20'],
    entao: 'Gerar bônus de 5.000 pontos',
  },
];

export default function PortalRegras() {
  return (
    <section id="regras" className="scroll-mt-28 bg-background-100 py-20 md:py-28">
      <div className="mx-auto w-full max-w-[1240px] px-6">
        <div className="mx-auto mb-14 max-w-3xl text-center">
          <span className="inline-flex items-center rounded-full border border-primary-200 bg-primary-50 px-4 py-1.5 text-[11px] font-semibold uppercase tracking-[0.22em] text-primary-700">
            Plataforma
          </span>
          <h2 className="mt-5 font-heading text-3xl font-bold leading-[1.1] tracking-[-0.02em] text-foreground-950 md:text-5xl">
            Portal de campanhas e <span className="text-primary-600">motor de regras</span>
          </h2>
          <p className="mt-5 text-base leading-relaxed text-foreground-600">
            Crie campanhas sem programar cada regra. O motor calcula a elegibilidade automaticamente.
          </p>
        </div>

        <div className="grid gap-5 lg:grid-cols-2">
          <article className="rounded-3xl border border-background-200 bg-background-50 p-7 md:p-8">
            <div className="flex items-center justify-between">
              <h3 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">Nova campanha</h3>
              <span className="rounded-full bg-accent-100 px-3 py-1 text-xs font-semibold text-accent-700">Rascunho</span>
            </div>

            <div className="mt-6 space-y-4">
              <div>
                <p className="text-xs font-semibold uppercase tracking-wider text-foreground-500">Nome</p>
                <p className="mt-1 text-sm font-semibold text-foreground-900">{PORTAL.nome}</p>
              </div>
              <div>
                <p className="text-xs font-semibold uppercase tracking-wider text-foreground-500">Público</p>
                <div className="mt-2 flex flex-wrap gap-2">
                  {PORTAL.publico.map((p) => (
                    <span key={p} className="rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-800">
                      {p}
                    </span>
                  ))}
                </div>
              </div>
              <div>
                <p className="text-xs font-semibold uppercase tracking-wider text-foreground-500">Período</p>
                <p className="mt-1 text-sm text-foreground-700">{PORTAL.periodo}</p>
              </div>
            </div>

            <div className="mt-6 space-y-2">
              {PORTAL.regras.map((r) => (
                <div key={r.faixa} className="flex items-center justify-between rounded-xl bg-background-100 px-4 py-3">
                  <span className="text-sm font-medium text-foreground-800">{r.faixa}</span>
                  <span className="whitespace-nowrap rounded-full bg-primary-500 px-3 py-1 text-xs font-bold text-white">
                    {r.premio}
                  </span>
                </div>
              ))}
            </div>

            <div className="mt-6">
              <p className="text-xs font-semibold uppercase tracking-wider text-foreground-500">Critérios de elegibilidade</p>
              <div className="mt-3 flex flex-wrap gap-2">
                {PORTAL.criterios.map((c) => (
                  <span key={c} className="inline-flex items-center gap-1.5 rounded-full border border-background-200 bg-background-50 px-3 py-1.5 text-xs font-medium text-foreground-700">
                    <i className="ri-checkbox-circle-line text-accent-600"></i>
                    {c}
                  </span>
                ))}
              </div>
            </div>
          </article>

          <article className="rounded-3xl border border-background-200 bg-foreground-900 p-7 md:p-8">
            <div className="flex items-center justify-between">
              <h3 className="font-heading text-xl font-bold text-background-50 md:text-2xl">Campaign Rules Engine</h3>
              <span className="rounded-full bg-white/10 px-3 py-1 text-xs font-semibold text-background-100">Motor de regras</span>
            </div>
            <p className="mt-3 text-sm leading-relaxed text-background-200">
              Configure condições e resultados sem código. A GetPoints avalia cada evento e gera a premiação de forma escalável.
            </p>

            <div className="mt-6 space-y-4">
              {MOTOR_REGRAS.map((regra) => (
                <div key={regra.se} className="rounded-2xl border border-white/10 bg-white/5 p-5">
                  <div className="flex items-center gap-2 text-background-100">
                    <span className="rounded-md bg-accent-500 px-2 py-0.5 font-heading text-xs font-bold text-white">SE</span>
                    <span className="font-mono text-sm">{regra.se}</span>
                  </div>
                  <div className="mt-3 space-y-1.5">
                    {regra.e.map((cond) => (
                      <div key={cond} className="flex items-center gap-2 text-background-200">
                        <span className="rounded-md bg-secondary-500 px-2 py-0.5 font-heading text-xs font-bold text-white">E</span>
                        <span className="font-mono text-sm">{cond}</span>
                      </div>
                    ))}
                  </div>
                  <div className="mt-4 flex items-center gap-2 border-t border-white/10 pt-3 text-background-50">
                    <span className="rounded-md bg-primary-500 px-2 py-0.5 font-heading text-xs font-bold text-white">ENTÃO</span>
                    <span className="text-sm font-semibold">{regra.entao}</span>
                  </div>
                </div>
              ))}
            </div>
          </article>
        </div>
      </div>
    </section>
  );
}